import React from 'react';
import Card from './card';

const Welcome = (props) => (
  <Card
    title="In order to get you a pre-approval letter, we need to ask you some questions. This should take approximately five minutes."
    {...props}
  />
);
Welcome.id = 'PreapprovalWelcome';
Welcome.completed = ({ model }) => model.getIn(['loan', 'termsAgree']);
export default Welcome;



// WEBPACK FOOTER //
// ./src/cards/welcome/preapproval.js